<template>
  <v-row>
    <v-col>
      <v-card>
        <v-row align="center">
          <v-col cols="3">
            <v-card-title
              >Envelope Nº {{ caixaExtrato.caixa.numero }}</v-card-title
            >
          </v-col>
          <v-col>
            <v-card-text class="d-flex justify-space-around text-subtitle-1">
              <span>
                Aberto em:
                {{
                  caixaExtrato.caixa.data_hora_abertura | toBrazilianDateTime
                }}
              </span>
              <span v-if="caixaExtrato.caixa.data_hora_fechamento">
                Fechado em:
                {{
                  caixaExtrato.caixa.data_hora_fechamento
                    | toBrazilianDateTime
                }}
              </span>
              <span> Data/Hora Atual: {{ now | toBrazilianDateTime }}</span>
              <span> Colaborador: {{ caixaExtrato.caixa.colaborador }}</span>
            </v-card-text>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { toBrazilianDateTime } from '@/mixins/convertion'
import { mapState } from 'vuex'

export default {
  name: 'ExtratoHeader',
  data() {
    return {
      now: new Date(),
      timer: null,
    }
  },
  computed: {
    ...mapState('caixa', ['caixaExtrato']),
  },
  filters: {
    toBrazilianDateTime,
  },
  created() {
    this.timer = setInterval(() => {
      this.now = new Date()
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
}
</script>
